const Ajax = require('jiji/infra/ajax');

class API {
    getOAuthClients() {
        return Ajax.GET('/admin/api/oauth/clients');
    }

    createOAuthClient(json) {
        return Ajax.POST('/admin/api/oauth/clients', json);
    }

    updateOAuthClient(id, json) {
        return Ajax.PUT(`/admin/api/oauth/clients/${id}`, json);
    }

    deleteOAuthClient(id) {
        return Ajax.DELETE(`/admin/api/oauth/clients/${id}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./jiji/infra/api/admin.js